import AuthenticatorHero from "../components/authenticator/AuthHero";
import AuthTechnology from "../components/authenticator/AuthTechnology";
import AuthHowItWorks from "../components/authenticator/AuthHowItWorks";
import AuthResults from "../components/authenticator/AuthResults";
import AuthCTA from "../components/authenticator/AuthCTA";
import Footer from "./Footer";
import ScrollToTopButton from "../components/authenticator/ScrollToTopButton";

function AuthenticatorPage() {
  return (
    <div className="bg-white">
      <AuthenticatorHero />
      <AuthTechnology />
      <AuthHowItWorks />
      <AuthResults />
      <AuthCTA />
      <ScrollToTopButton />
      <Footer />
    </div>
  );
}

export default AuthenticatorPage;